export { HTMLEditorState as default };

/**
* HTML Editor State
*
* Entity to hold editor state params
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class HTMLEditorState {
  /**
   * Background Color
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  background_color;

  /**
   * Foreground Color
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  color;

  /**
   * Font Family
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  font;

  /**
   * Text Size
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  size;

  /**
   * Text Alignement
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  alignment;

  /**
   * Has Bold
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  bold = false;

 /**
   * Has Italic
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  italic = false;

 /**
   * Has Underline
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  underline = false;

 /**
   * Is Striked
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  strike = false;

 /**
   * Has Unordered list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  unordered_list = false;

 /**
   * Has Ordered list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  ordered_list = false;

 /**
   * Has Quote
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  quote = false;

  /**
   * Has Code
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  code = false;

  /**
   * Defines if in selection state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Boolean}
   */
  selection = false;
}